import * as React from "react";
import Svg, { Path } from "react-native-svg";

function EmptyOrdersGraphic(props) {
  return (
    <Svg width={220} height={160} viewBox="0 0 220 160" fill="none" {...props}>
      <Path d="M185 150.043H83.778v.437H185v-.437z" fill="#3F3D56" />
      <Path
        d="M166.11 75.803a2.16 2.16 0 01.493 1.674 2.143 2.143 0 01-.913 1.487l-10.476 7.193-4.613 3.075a1.268 1.268 0 01-1.685-.252 1.272 1.272 0 01-.056-1.532 1.26 1.26 0 01.401-.368l4.468-2.594 7.797-7.427-5.012-5.384 3.713-2.784 5.883 6.912zM141.476 143.522h-2.563l-1.522-21.164 6.498-.186-2.413 21.35z"
        fill="#A0616A"
      />
      <Path
        d="M141.661 150.392c-.683.312-1.255-2.214-1.832-1.648-1.612 1.584-4.081 1.929-6.232 1.237l.753-.008a1.004 1.004 0 01-.699-.913 1.012 1.012 0 01.064-.4 1.008 1.008 0 01.699-.624l1.714-.429 2.692-4.734 2.748-.185a6.573 6.573 0 011.215 5.601c-.25 1.017-.635 1.881-1.122 2.103z"
        fill="#2F2E41"
      />
      <Path
        d="M158.538 143.523h-2.563l-1.522-21.165 6.684-1.299-2.599 22.464z"
        fill="#A0616A"
      />
      <Path
        d="M158.723 150.394c-.683.312-1.255-2.214-1.832-1.648-1.612 1.584-4.081 1.929-6.232 1.238l.753-.009a1.004 1.004 0 01-.699-.913 1.007 1.007 0 01.763-1.024l1.714-.429 2.692-4.734 2.934-.371.074.121a7.573 7.573 0 01.811 6.186c-.244.781-.576 1.4-.978 1.583z"
        fill="#2F2E41"
      />
      <Path
        d="M161.443 69.37c-2.357.328-3.988 1.618-4.652 4.193l-4.332-7.998a2.365 2.365 0 01.755-3.007 2.368 2.368 0 013.216.47l5.013 6.342z"
        fill="#E40046"
      />
      <Path
        d="M165.982 120.131c-10.532 4.66-21.31 5.233-32.304 2.228 4.015-15.571 8.755-29.65 8.726-41.216l10.768-.928 1.658 2.628a58.326 58.326 0 018.002 20.41l3.15 16.878z"
        fill="#2F2E41"
      />
      <Path
        d="M148.345 57.194a5.57 5.57 0 100-11.138 5.57 5.57 0 000 11.138z"
        fill="#A0616A"
      />
      <Path
        d="M154.471 61.465l-6.869.371-1.114-6.127 5.57-.928 2.413 6.684z"
        fill="#A0616A"
      />
      <Path
        d="M153.729 81.143l-7.526.212-3.799.53c-1.865-6.16-3.435-12.306.371-17.45l4.456-4.456 6.683-.186.089.05a5.382 5.382 0 012.466 6.262c-1.659 5.39-2.724 10.48-2.74 15.038z"
        fill="#E40046"
      />
      <Path
        d="M142.218 98.407l-.467 6.38a1.423 1.423 0 01-1.322 1.314 1.42 1.42 0 01-1.516-1.451l.149-6.243 4.641-17.637.186-10.768 5.198-.186-.371 12.44-6.498 16.151z"
        fill="#A0616A"
      />
      <Path
        d="M149.644 70.749c-2.204-.896-4.262-.596-6.126 1.3l.255-9.092a2.365 2.365 0 012.159-2.225 2.37 2.37 0 012.549 2.018l1.163 7.999z"
        fill="#E40046"
      />
      <Path
        d="M160.134 76.41h-17.08c3.984-10.552 5.269-20.367 0-28.777.09-2.526 3.33-4.716 5.846-4.474 2.971.286 6.964 2.47 7.521 5.402l3.713 27.848z"
        fill="#2F2E41"
      />
      <Path
        d="M105.7 42.694h-.779V21.352a12.349 12.349 0 00-3.618-8.734A12.353 12.353 0 0092.568 9H47.352A12.352 12.352 0 0035 21.352v117.085a12.353 12.353 0 0012.352 12.352h45.216a12.347 12.347 0 0011.412-7.625 12.35 12.35 0 00.941-4.727v-80.55h.779V42.693z"
        fill="#3F3D56"
      />
      <Path
        d="M93.067 12.21h-5.902a4.381 4.381 0 01-4.058 6.039H57.203a4.384 4.384 0 01-4.057-6.038h-5.513a9.224 9.224 0 00-9.225 9.224v116.913a9.223 9.223 0 009.225 9.225h45.434a9.235 9.235 0 006.523-2.702 9.225 9.225 0 002.701-6.523V21.435a9.226 9.226 0 00-9.224-9.224z"
        fill="#fff"
      />
      <Path d="M94.313 30.477H46.386v41.108h47.927V30.477z" fill="#E6E6E6" />
      <Path
        d="M60.609 80.158a3.507 3.507 0 100-7.013 3.507 3.507 0 000 7.013z"
        fill="#E40046"
      />
      <Path
        d="M62.362 76.36h-1.461v-1.462h-.585v1.462h-1.46v.584h1.46v1.461h.585v-1.46h1.461v-.585z"
        fill="#fff"
      />
      <Path
        d="M79.117 80.158a3.507 3.507 0 100-7.013 3.507 3.507 0 000 7.013z"
        fill="#E40046"
      />
      <Path d="M80.87 76.94v-.584h-3.507v.584h3.507z" fill="#fff" />
      <Path
        d="M72.137 35.602H68.35a.502.502 0 00-.502.502v1.662a.502.502 0 00.502.502h.628v2.491h2.532v-2.49h.627a.503.503 0 00.502-.503v-1.662a.502.502 0 00-.502-.502z"
        fill="#FFB800"
      />
      <Path
        d="M75.93 50.817a19.471 19.471 0 01-3.387-11.544.41.41 0 00-.32-.41v-.718h-4v.708h-.055a.41.41 0 00-.41.44c.316 4.394-.748 8.333-3.191 11.819-.141.2-.213.44-.205.685l.437 13.53a1.171 1.171 0 001.161 1.13h9.048a1.171 1.171 0 001.162-1.15l.168-13.136a2.37 2.37 0 00-.407-1.354z"
        fill="#3F3D56"
      />
      <Path
        opacity={0.2}
        d="M71.348 36.145a1.083 1.083 0 11-2.167 0"
        fill="#000"
      />
      <Path
        d="M74.499 55.313h-1.096a2.875 2.875 0 00-5.684 0h-1.095a.809.809 0 00-.8.931l1.19 7.735h6.834l1.445-7.709a.809.809 0 00-.794-.958z"
        fill="#FFB800"
      />
      <Path d="M94.313 88.34H46.386v41.108h47.927V88.34z" fill="#E6E6E6" />
      <Path
        d="M60.609 138.021a3.507 3.507 0 100-7.013 3.507 3.507 0 000 7.013z"
        fill="#E40046"
      />
      <Path
        d="M62.362 134.223h-1.461v-1.461h-.585v1.461h-1.46v.584h1.46v1.462h.585v-1.462h1.461v-.584z"
        fill="#fff"
      />
      <Path
        d="M79.117 138.021a3.507 3.507 0 100-7.013 3.507 3.507 0 000 7.013z"
        fill="#E40046"
      />
      <Path
        d="M80.87 134.803v-.584h-3.507v.584h3.507zM79.785 117.545h.026a4.488 4.488 0 004.203-2.816 14.69 14.69 0 00-10.826-19.82 14.693 14.693 0 00-8.747 27.869 4.448 4.448 0 004.943-.917 14.65 14.65 0 0110.4-4.316z"
        fill="#fff"
      />
      <Path
        d="M72.237 113.095a4.852 4.852 0 100-9.704 4.852 4.852 0 000 9.704z"
        fill="#F9A825"
      />
    </Svg>
  );
}

export default EmptyOrdersGraphic;
